// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a920bf4e","239":"c4846873","422":"21563b31","430":"3c9a3455","455":"e85f1f20","639":"e35cdc94"}[chunkId] + ".chunk.js";
};